<template>
    <div>

        <FullCalendar
            ref="fullCalendar"
            :options="config"/>

        <!-- modal -->
        <div v-if="modal.isOpen" class="absolute inset-0 z-20 flex justify-center items-center">
            <div class="relative max-w-md w-full p-8 rounded bg-white shadow-2xl border border-gray-200 pointer-events-auto">
                <button class="absolute p-4 top-0 right-0 text-muted outline-none cursor-pointer focus:outline-none" role="button" @click="modal.isOpen = false">
                    <icon name="x"/>
                </button>

                <div class="text-2xl font-bold">
                    {{ modal.slot.start.toCsDayOfWeekString() }}
                </div>

                <div class="flex items-center text-2xl tracking-wider">
                    <TimePicker
                        v-model="modal.slot.start"
                        :max="modal.slot.end"
                        @input="triggerRefresh()"
                        />
                    <span class="mx-4">-</span>
                    <TimePicker
                        v-model="modal.slot.end"
                        :min="modal.slot.start"
                        @input="triggerRefresh()"
                        />
                </div>

                <div class="mt-4 flex justify-between">
                    <button
                        class="btn btn--primary"
                        @click="handleModalOk()"
                    >Nastavit</button>

                    <button
                        class="btn bg-error border-error text-white"
                        @click="handleModalDelete()"
                    ><icon name="trash-2"/></button>
                </div>
            </div>
        </div>
        <!-- /modal -->

    </div>
</template>

<script>
import FullCalendar from '@fullcalendar/vue';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import Slot from '@/components/Slot';
import TimePicker from '@/components/TimePicker';

export default {
    components: {
        FullCalendar,
        TimePicker
    },

    props: [
        'resource'
    ],

    data() {
        return {
            calendarApi: null,
            firstDayOfWeek: null,
            modal: {
                isOpen: false,
                slot: null,
                triggerRefresh: true // by altering this value we can force computed opendSlots() to refresh and rerender in calednar
            }
        }
    },

    computed: {
        openSlots() {
            this.modal.triggerRefresh;
            return this.$store.openSlots;
        },
        config() {
            return {
                ...this.configOptions,
                ...this.eventHandlers,
            }
        },
        configOptions() {
            return {
                plugins: [interactionPlugin, timeGridPlugin],
                initialView: 'timeGridWeek',
                firstDay: 1,
                locale: 'cs',
                headerToolbar: {
                    left: '',
                    center: '',
                    right: ''
                },
                dayHeaderContent: (arg) => arg.date.toCsDayOfWeekString(),
                allDaySlot: false,
                height: '100%',

                selectable: true,
                selectOverlap: false,

                eventSources: [
                    {
                        events: this.openSlots,
                    },
                ],
            }
        },
        eventHandlers() {
            return {
                select: (info) => {
                    let slot = new Slot({
                        start: info.start,
                        end: info.end
                    });
                    this.addSlot(slot);
                },

                eventClick: (info) => {
                    this.openSlotModal(info.event.id);
                },

                eventDidMount: (info) => {
                    info.el.setAttribute('data-id', info.event.id);
                }
            }
        }
    },

    methods: {

        async fetchOpenSlots() {
            const response = await axios.get(`/resources/${this.resource.id}/open-slots`);
            this.$store.openSlots = response.data.openSlots.map(slot => new Slot(slot));
        },

        findSlot(slotId) {
            return this.$store.openSlots
                .find(({id}) => id === slotId);
        },

        findSlotIndex(slotId) {
            return this.$store.openSlots
                .findIndex(({id}) => id === slotId);
        },

        openSlotModal(id) {
            this.modal.slot = this.findSlot(id);
            this.modal.isOpen = true;
        },

        addSlot(slot) {
            this.$store.openSlots.push(slot);
            this.$emit('changed', true);
        },

        deleteSlot(id) {
            let index = this.findSlotIndex(id);
            this.$store.openSlots.splice(index, 1);
        },

        handleModalOk() {
            this.modal.isOpen = false;
        },

        handleModalDelete() {
            this.modal.isOpen = false;
            this.deleteSlot(this.modal.slot.id);
        },

        triggerRefresh() {
            this.modal.triggerRefresh = ! this.modal.triggerRefresh;
        }
    },

    mounted() {
        if (this.resource.id) {
            this.fetchOpenSlots();
        }
    }
};
</script>
